import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { useNullableNationalAccountInfo } from "../stores/hooks/useNullableNationalAccountInfo";
import { Language } from "./useLanguage";

export const useAvailableLanguages = (): Language[] => {
  const dealer = useNullableDealerAccountInfo();
  const national = useNullableNationalAccountInfo();
  return (
    dealer?.dealerLanguageSet ?? national?.nationalLanguageSet ?? ["en", "fr"]
  );
};
